module.exports = __webpack_public_path__ + "static/media/beer.7111053b.png";